<div class="set-blackout">
  <header class="set-blackout-head">
    <h2 class="set-blackout-title" [id]="titleId">Set blackout</h2>
    @if ($caption()) {
      <p class="set-blackout-copy">{{ $caption() }}</p>
    }
  </header>

  <!-- The dialog opens on a day, not on the chevron: the calendar marks its roving tab stop as the
       autofocus control, so a keyboard user can start arrowing immediately. -->
  <div class="set-blackout-calendar" data-autofocus="true">
    <wb-mini-calendar [mode]="MiniCalendarMode.Range" [months]="2" [showToday]="true" [range]="$range()" (rangeChange)="onRangeChange($event)" />
  </div>

  <!-- One line, not two boxes: it is the only confirmation a range changed, hence `aria-live`. `Clear`
       rides on the same line rather than in the footer, because it undoes the pick the line reports,
       not the dialog. -->
  <div class="set-blackout-summary-row">
    <p class="set-blackout-summary" aria-live="polite">{{ $summary() }}</p>
    @if ($canClear()) {
      <wb-button-link buttonClass="set-blackout-clear" label="Clear" [size]="linkSize" (onClick)="clearRange()" />
    }
  </div>

  <label class="set-blackout-field">
    <span class="set-blackout-label">Reason (optional)</span>
    <input class="set-blackout-input" type="text" [value]="$reason()" (input)="onReasonInput($event)" />
  </label>

  <footer class="set-blackout-actions">
    <wb-button label="Cancel" [size]="buttonSize" (onClick)="cancel()" />
    <wb-button label="Add blackout" [displayStyle]="primary" [size]="buttonSize" [disabled]="!$canAdd()" (onClick)="add()" />
  </footer>
</div>
